<template>
  <div>
    <div class="button">
      <el-button type="primary" @click="getPdf()">导出数据</el-button>
      <!-- <el-button icon="el-icon-close" type="info" circle @click="retura"></el-button> -->
    </div>
    <div class="context" style="height: calc(100vh - 400px);overflow-y: auto;">
      <div id="pdfget">
        <div class="titile1">{{questionObject.name}}</div>
        <div class="da" v-for="(item,index) in allData" :key="index" v-show="item.type!==3">
          <div class="contexa">
            <div>{{index+1}}.{{item.name}}</div>
            <el-table :data="item.choiceList" style="width: 100%;" stripe>
              <el-table-column prop="name" label="选项"></el-table-column>
              <el-table-column label="百分比">
                <template slot-scope="scope">
                  <el-progress
                    :text-inside="true"
                    :stroke-width="26"
                    :percentage="scope.row.percentage"
                  ></el-progress>
                </template>
              </el-table-column>
              <el-table-column prop="count" label="数量" align="center"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import html2Canvas from 'html2canvas';
import JsPDF from 'jspdf';
import * as vote from '@/api/vote/vote.js';

export default {
  components: {},
  props: {
    topicId: Number,
  },
  data() {
    return {
      dialogVisible: false,
      activeName: 'first',
      currentPage: 1,
      pageSize: 10,
      allData: '',
      questionObject: '',
      chartData: [],
    };
  },
  created() {
    this.getlist();
  },
  methods: {
    getPdf() {
      let title = this.questionObject.name;
      let imageWrapper = document.querySelector('#pdfget');
      html2Canvas(imageWrapper, {
        allowTaint: true,
        useCORS: true,
        height: imageWrapper.offsetHeight, // 下面解决当页面滚动之后生成图片出现白边问题
        width: imageWrapper.offsetWidth,
      }).then(function (canvas) {
        let contentWidth = canvas.width;
        let contentHeight = canvas.height;
        let pageHeight = (contentWidth / 592.28) * 841.89;
        let leftHeight = contentHeight;
        let position = 0;
        let imgWidth = 595.28;
        let imgHeight = (592.28 / contentWidth) * contentHeight;
        let pageData = canvas.toDataURL('image/jpeg', 1.0);
        let PDF = new JsPDF('', 'pt', 'a4');
        console.log(imgWidth, imgHeight);
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89;
            if (leftHeight > 0) {
              PDF.addPage();
            }
          }
        }
        PDF.save(title + '.pdf');
      });
    },
    retura() {
      let a = 1;
      this.$emit('onChange', a);
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    },

    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    getlist() {
      let than = this;
      let para = { topicId: this.topicId };
      //查询当前主题下的题目信息
      vote.getQuestionTJ(para).then((res) => {
        than.allData = res.result;
        // console.log(res.result);
      });
      let para2 = { id: this.topicId };
      //查询出当前单个主题的基本信息
      vote.getPollGetTongJi(para2).then((res) => {
        // console.log(res)
        this.questionObject = res.result;
      });
    },
  },
};
</script>
<style scoped>
.context {
  max-width: 1000px;

  padding: 20px;
  border: solid 1px #f2f2f2;
  background-color: #fff;
  margin: 0 auto;
  margin-top: 20px;
}
.titile1 {
  font-size: 20px;
  font-weight: 700;
  text-align: center;
}
.da {
  max-width: 800px;
  margin-left: 50px;
  /* height: 380px; */
  background-color: #fff;
  margin-top: 20px;
}
.button {
  text-align: right;
  margin-right: 66px;
}
.heightlight {
  background-color: rgba(72, 118, 196, 0.95) !important;
  border: 1px solid #4876c4;
  color: #f8fafc !important;
}
.contexa {
  margin-left: 10px;
}
</style>
